import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import {IconButton} from 'shells/button/icon-button/icon-button';
// @ts-expect-error - imported from .js/.jsx file
import {SidebarIconSetupIcon} from 'shells/icon/svg/sidebar-icon-setup';

import type {
    GetNotifications as GetNotificationsQuery,
    GetNotifications_notifications as Notification,
} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {NotificationsMutations} from '../graphql/graphql-wrappers/notifications-mutations';
import GET_NOTIFICATIONS from '../graphql/queries/get-notifications.graphql';
import {SidebarDrawer} from '../sidebar-drawer';

import {NotificationList} from './notification-list';
import {useMarkAllSeen} from './use-mark-all-seen';

import styles from './new-sidebar-notifications.module.css';

type Props = {
    isActive: boolean;
    closeSidebar: () => void;
};

export function NewSidebarNotifications(props: Props) {
    const [previouslyIsActive, setPreviouslyIsActive] = React.useState(false);

    const {data, loading, error, startPolling, stopPolling, refetch} = useQuery<
        GetNotificationsQuery,
        Notification
    >(GET_NOTIFICATIONS, {
        fetchPolicy: 'cache-and-network',
    });

    const notifications = data ? data.notifications : null;
    const {user} = useGetSessionUser();

    const markAllSeen = useMarkAllSeen();

    React.useEffect(() => {
        setPreviouslyIsActive(props.isActive);

        if (props.isActive && props.isActive !== previouslyIsActive) {
            refetch();
            markAllSeen();
            startPolling(30000);
        } else if (!props.isActive) {
            stopPolling();
        }
    }, [markAllSeen, refetch, previouslyIsActive, startPolling, stopPolling, props.isActive]);

    const notificationModels = notifications || [];
    const isLoading = loading && !notifications;
    // @ts-expect-error
    const errorMessage = safelyGetGraphQLErrorMessage(error);
    const canAccessCrm = user && user.permissions.canAccessCrm;

    return (
        <div style={{display: props.isActive ? 'block' : 'none'}}>
            <NotificationsMutations>
                {({onMarkRead, onMarkAllRead}) => {
                    return (
                        <SidebarDrawer headerText='Notifications' hasNoTopPadding={true}>
                            <div className='notification-list-container'>
                                <div
                                    className={
                                        canAccessCrm
                                            ? styles['top-container']
                                            : styles['top-container-single']
                                    }
                                >
                                    {canAccessCrm ? (
                                        <>
                                            <IconButton
                                                icon={SidebarIconSetupIcon}
                                                noHoverBackground={true}
                                                isSmall={true}
                                                onClick={() => {
                                                    appHistory.push('/my-account/notifications');
                                                    props.closeSidebar();
                                                }}
                                                tooltipText='Notification settings'
                                            />
                                        </>
                                    ) : undefined}

                                    {notificationModels.length && !isLoading && !errorMessage ? (
                                        <div
                                            onClick={() => {
                                                onMarkAllRead().then(() => refetch());
                                            }}
                                            className={styles['mark-all']}
                                        >
                                            Mark all as read
                                        </div>
                                    ) : undefined}
                                </div>
                                <NotificationList
                                    notifications={notificationModels}
                                    isLoading={isLoading}
                                    errorMessage={errorMessage}
                                    onMarkRead={(id: string) => {
                                        onMarkRead(id).then(() => {
                                            refetch();
                                        });
                                    }}
                                    closeSidebar={props.closeSidebar}
                                />
                            </div>
                        </SidebarDrawer>
                    );
                }}
            </NotificationsMutations>
            ;
        </div>
    );
}
